/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MedicareEstimates } from './MedicareEstimates';
import {
    MedicareEstimatesFromJSON,
    MedicareEstimatesFromJSONTyped,
    MedicareEstimatesToJSON,
} from './MedicareEstimates';

/**
 * 
 * @export
 * @interface GetMedicareEstimates200Response
 */
export interface GetMedicareEstimates200Response {
    /**
     * 
     * @type {MedicareEstimates}
     * @memberof GetMedicareEstimates200Response
     */
    data?: MedicareEstimates;
}

/**
 * Check if a given object implements the GetMedicareEstimates200Response interface.
 */
export function instanceOfGetMedicareEstimates200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMedicareEstimates200ResponseFromJSON(json: any): GetMedicareEstimates200Response {
    return GetMedicareEstimates200ResponseFromJSONTyped(json, false);
}

export function GetMedicareEstimates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMedicareEstimates200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : MedicareEstimatesFromJSON(json['data']),
    };
}

export function GetMedicareEstimates200ResponseToJSON(value?: GetMedicareEstimates200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': MedicareEstimatesToJSON(value.data),
    };
}

